import { formatTwitterLink } from '@benzinga/utils';

function asHttpsHref(value: string): string {
  if (value.startsWith('//')) return `https:${value}`;
  return value;
}

/** Maps v2 author API social_* fields (handle or absolute URL) to a usable anchor href */
export function authorTwitterHref(raw: string | null | undefined): string | null {
  const v = typeof raw === 'string' ? raw.trim() : '';
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return asHttpsHref(v);
  if (/^(x\.com|twitter\.com)\b/i.test(v)) return `https://${v}`;
  return formatTwitterLink(v.replace(/^@/, ''));
}

export function authorFacebookHref(raw: string | null | undefined): string | null {
  const v = typeof raw === 'string' ? raw.trim() : '';
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return asHttpsHref(v);
  if (v.startsWith('//')) return `https:${v}`;
  return `https://facebook.com/${v.replace(/^@/, '').replace(/^\//, '')}`;
}

export function authorLinkedinHref(raw: string | null | undefined): string | null {
  const v = typeof raw === 'string' ? raw.trim() : '';
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return asHttpsHref(v);
  if (v.startsWith('//')) return `https:${v}`;
  const h = v.replace(/^@/, '');
  if (/linkedin\.com\b/i.test(h)) {
    const stripped = h.replace(/^https?:\/\//i, '').replace(/^\/+/, '');
    return `https://${stripped}`;
  }
  return `https://www.linkedin.com/in/${encodeURIComponent(h)}`;
}

export function authorInstagramHref(raw: string | null | undefined): string | null {
  const v = typeof raw === 'string' ? raw.trim() : '';
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return asHttpsHref(v);
  if (v.startsWith('//')) return `https:${v}`;
  const h = v.replace(/^@/, '').replace(/^\//, '');
  return `https://www.instagram.com/${encodeURIComponent(h)}`;
}

export function authorThreadsHref(raw: string | null | undefined): string | null {
  const v = typeof raw === 'string' ? raw.trim() : '';
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return asHttpsHref(v);
  if (v.startsWith('//')) return `https:${v}`;
  const uname = v.replace(/^@/, '');
  return `https://www.threads.net/@${uname}`;
}

export function authorTiktokHref(raw: string | null | undefined): string | null {
  const v = typeof raw === 'string' ? raw.trim() : '';
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return asHttpsHref(v);
  if (v.startsWith('//')) return `https:${v}`;
  const uname = v.replace(/^@/, '');
  return `https://www.tiktok.com/@${uname}`;
}

export function authorHomepageHref(raw: string | null | undefined): string | null {
  const v = typeof raw === 'string' ? raw.trim() : '';
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return asHttpsHref(v);
  if (v.startsWith('//')) return `https:${v}`;
  return `https://${v.replace(/^\/+/, '')}`;
}
